var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnschlussauswahl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 68.702,
    viewBox: "0 0 72 68.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1472",
    "data-name": "Gruppe 1472",
    transform: "translate(173.797 -1134.628) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4329",
    "data-name": "Pfad 4329",
    d: "M1143.145,197.519V185.766h11.621v12.017",
    transform: "translate(-5.386 -59.445)",
    fill: "none",
    stroke: "#00c713",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_423",
    "data-name": "Linie 423",
    y1: 15.015,
    transform: "translate(1139.823 110.395)",
    fill: "none",
    stroke: "#00c713",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_424",
    "data-name": "Linie 424",
    y1: 15.015,
    transform: "translate(1143.443 110.395)",
    fill: "none",
    stroke: "#00c713",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_425",
    "data-name": "Linie 425",
    y1: 15.015,
    transform: "translate(1147.196 110.395)",
    fill: "none",
    stroke: "#00c713",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1281",
    "data-name": "Gruppe 1281",
    transform: "translate(1135.628 102.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4330",
    "data-name": "Pfad 4330",
    d: "M1186.736,168.568V162.6a4.8,4.8,0,0,0-4.8-4.8h-.724a4.8,4.8,0,0,0-4.8,4.8v27.455a20.393,20.393,0,1,1-40.786,0V178.468h15.594v11.583a4.8,4.8,0,1,0,9.6,0V174.324",
    transform: "translate(-1135.628 -142.203)",
    fill: "none",
    stroke: "#00467d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4331",
    "data-name": "Pfad 4331",
    d: "M1224.479,129.362V123.19a20.416,20.416,0,0,1,20.393-20.393h.724a20.417,20.417,0,0,1,20.393,20.393V172.8H1250.4V134.719",
    transform: "translate(-1199.287 -102.797)",
    fill: "none",
    stroke: "#00467d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linie_426",
    "data-name": "Linie 426",
    x2: 10.696,
    transform: "translate(1138.156 134.245)",
    fill: "none",
    stroke: "#00c713",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnschlussauswahl);
export default __webpack_public_path__ + "static/media/Anschlussauswahl.12f6a6e7d6e4473b230ef4ffc4e1a0a3.svg";
export { ForwardRef as ReactComponent };